import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/home/index.vue'
import ServerError from '../views/500.vue'
import { getToken } from '@/utils/auth'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    beforeEnter: (to, from, next) => {
      if (to.name === 'Home' && getToken()) {
        next({ path: '/account' })
      } else {
        next()
      }
    },
  },
  {
    path: '/500',
    name: '500',
    component: ServerError,
  },
  {
    path: '/account',
    name: 'Account',
    meta: { name: 'account' },
    component: () => {
      return import(
        /* webpackChunkName: "account" */ '../views/account/index.vue'
      )
    },
  },
  {
    path: '/billing',
    name: 'Billing',
    meta: { name: 'billing' },
    component: () => {
      return import(
        /* webpackChunkName: "billing" */ '../views/billing/index.vue'
      )
    },
  },
  {
    path: '/links',
    name: 'Links',
    meta: { name: 'links' },
    component: () => {
      return import(/* webpackChunkName: "links" */ '../views/links/index.vue')
    },
  },
  {
    path: '/statistics',
    name: 'Statistics',
    meta: { name: 'statistics' },
    component: () => {
      return import(
        /* webpackChunkName: "statistics" */ '../views/statistics/index.vue'
      )
    },
  },
]

const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHashHistory(),
  routes,
  // 页面自动滚动至顶部
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { top: 0, left: 0, behavior: 'smooth' }
  },
})

export default router
